import type { MarketVariants } from '@/lib/i18n'

export type Slide2TwoSpeedsCopy = {
  eyebrow: string
  title: string
  fastLabel: string
  fastBullet1: string
  fastBullet2: string
  fastBullet3: string
  slowLabel: string
  slowBullet1: string
  slowBullet2: string
  slowBullet3: string
}

export const copy: MarketVariants<Slide2TwoSpeedsCopy> = {
  US: {
    eyebrow: "Here's why",
    title: 'Your brain has two speeds',
    fastLabel: 'Fast mode',
    fastBullet1: 'Quick, emotional reactions',
    fastBullet2: '"Act now. Think later."',
    fastBullet3: 'Makes red flags easier to miss',
    slowLabel: 'Slow mode',
    slowBullet1: 'Calm, careful thinking',
    slowBullet2: '"Wait. Does this add up?"',
    slowBullet3: 'Helps you spot red flags',
  },
  ar: {
    eyebrow: 'إليك السبب',
    title: 'دماغك يعمل بسرعتين',
    fastLabel: 'الوضع السريع',
    fastBullet1: 'ردود فعل سريعة وعاطفية',
    fastBullet2: '"تصرّف الآن. فكّر لاحقاً."',
    fastBullet3: 'يجعلك أكثر عرضة لتفويت إشارات الخطر',
    slowLabel: 'الوضع البطيء',
    slowBullet1: 'تفكير هادئ ومتأنٍّ',
    slowBullet2: '"انتظر. هل هذا منطقي؟"',
    slowBullet3: 'يساعدك على رصد إشارات الخطر',
  },
}
